import { Component, OnInit } from '@angular/core';
import { Validators, UntypedFormControl, UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService, JSONRPCError, JSONRPCErrorCode, JSONRPCUserErrorCode, UUID } from '@s8l/client-tree-lib';

import { AlertService } from 'src/app/services/alert.service';
import { UserServerService } from 'src/app/services/jsonrpc/user-server.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  public userform = this.fb.group({
    username: new UntypedFormControl('', Validators.required),
    password: new UntypedFormControl('', Validators.required)
  });

  public loading = false;

  constructor(
    private fb: UntypedFormBuilder,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private user: UserServerService,
    private auth: AuthService,
    private alert: AlertService
  ) {}

  public ngOnInit() {
    if (this.auth.isAuth) {
      return this.navigate();
    }
  }

  public async onSubmit() {
    this.loading = true;

    await this.user
      .accountLogin({
        username: this.userform.controls.username.value,
        password: this.userform.controls.password.value,
        app: 'cms',
        device: {
          // platform: Browser.GetPlatformType(),
          id: UUID.random()
        }
      })
      .then(res => {
        // Server has set HttpOnly cookie, store profile and mark as authenticated
        this.auth.auth(res.profile);
        return this.navigate();
      })
      .catch(err => {
        if (err instanceof JSONRPCError) {
          switch (err.code) {
            case JSONRPCErrorCode.UNAUTHORIZED:
              if (err.message == 'Insufficient permission') {
                throw err;
              }
              return this.loginError();
            case JSONRPCUserErrorCode.PROFILE_MISSING:
            case JSONRPCUserErrorCode.LOGIN_ERROR:
            case JSONRPCUserErrorCode.PASSWORD_INVALID:
              return this.loginError();
          }
        }
        throw err;
      })
      .finally(() => (this.loading = false));
  }

  private loginError() {
    return this.alert.fireError('Login Failed', 'The username or the password you provided is wrong.').then(() => {
      this.userform.reset();
    });
  }

  private navigate() {
    const path = this.activeRoute.snapshot.paramMap.get('returnTo') || '/home';
    return this.router.navigateByUrl(path, { replaceUrl: true });
  }
}
